import { render, staticRenderFns } from "./ReviewerFeesStat.vue?vue&type=template&id=163c28fe&scoped=true"
import script from "./ReviewerFeesStat.vue?vue&type=script&lang=js"
export * from "./ReviewerFeesStat.vue?vue&type=script&lang=js"
import style0 from "./ReviewerFeesStat.vue?vue&type=style&index=0&id=163c28fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163c28fe",
  null
  
)

export default component.exports